import type { TFunction } from "i18next";

import type { SeatHolders } from "shared/api/useSeatHolders";
import { seatHolder } from "shared/api/useSeatHolders";
import { roleLabel } from "shared/vocab/workflowState";

/**
 * The confirmation after a plan moves, keyed on the action taken (D1).
 *
 * Round 18 N11 named the person where one holds the seat it went to.
 * Round 19 N14 -- four held the approver's seat and the toast read
 * "It is now with the Approver.": several holders now say how many and
 * name one with the count of the others, and an empty seat says so.
 */
export function capMovedMessage(
  t: TFunction,
  key: string,
  to: string,
  seats: SeatHolders | undefined,
): string {
  const forwarded = key === "caps.detail.done.approve";
  if (forwarded && to) {
    const holder = seatHolder(seats, to);
    const position = roleLabel(to);
    if (holder.kind === "named")
      return t("caps.detail.done.approveNamed", { name: holder.name, position });
    const people = [...new Set(seats?.holders?.[to] ?? [])];
    if (people.length > 1)
      return t("caps.detail.done.approveSeveral", {
        position,
        holders: people.length,
        name: people[0],
        count: people.length - 1,
      });
    if (holder.kind === "nobody")
      return t("caps.detail.done.approveNobody", { position });
  }
  return t(key, { position: to ? roleLabel(to) : "" });
}
